import { render, staticRenderFns } from "./ArticleCategory.vue?vue&type=template&id=42095346&scoped=true&"
import script from "./ArticleCategory.vue?vue&type=script&lang=js&"
export * from "./ArticleCategory.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCategory.vue?vue&type=style&index=0&id=42095346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42095346",
  null
  
)

export default component.exports